var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPassengers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15.73,
    viewBox: "0 0 12 15.73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -12.484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 106.057c-2 0-6 1.722-6 5.14v2.57h12V111.2c0-3.421-4-5.143-6-5.143z",
    className: "cls-1",
    transform: "translate(0 -85.552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.932 12.484a3.381 3.381 0 1 0 3.381 3.381 3.38 3.38 0 0 0-3.381-3.381z",
    className: "cls-1",
    transform: "translate(-27.932)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPassengers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/passengers.4c348928.svg";
export { ForwardRef as ReactComponent };